module.exports = __webpack_public_path__ + "static/img/mine.b4e3b2d6.png";